import {
  handleSocketTransactionFailure,
  handleSocketTransactionSuccess,
} from './actions';

/**
 * Consumed by Socket context to register listeners
 */
const createTransactionSockethandlers = (dispatch, socket) => {
  socket.on('ctx.error', (message) => {
    const { text } = message;
    // Sanitize the error message to prevent React serialization issues
    const sanitizedText =
      typeof text === 'string'
        ? text
        : 'An error occurred during transaction creation';
    dispatch(handleSocketTransactionFailure(sanitizedText));
  });

  socket.on('ctx.success', (message) => {
    const { payload, text } = message;
    dispatch(handleSocketTransactionSuccess({ payload, text }));
  });
};

export default createTransactionSockethandlers;
